import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProjectListComponent } from './list/project-list.component';
import { ProjectDetailComponent } from './detail/project-detail.component';
import { AuthGuard } from '../auth/auth.guard';
import { ProjectDetailMainComponent } from './detail/project-detail-main/project-detail-main.component';
import { ProjectDetailObjectsComponent } from './detail/project-detail-objects/project-detail-objects.component';
import { ProjectDetailWidgetsComponent } from './detail/project-detail-widgets/project-detail-widgets.component';
import { ProjectDetailWidgetDetailComponent } from './detail/project-detail-widget-detail/project-detail-widget-detail.component';
import { ProjectDetailFeedComponent } from './detail/project-detail-feed/project-detail-feed.component';
import { ProjectDetailApiComponent } from './detail/project-detail-api/project-detail-api.component';

export const projectsRoutes: Routes = [
  {
    path: 'projects',
    component: ProjectListComponent,
    data: {
      title: 'Projekt'
    }
  },
  {
    path: 'projects/:id',
    component: ProjectDetailComponent,
    children: [
      {
        path: '',
        component: ProjectDetailMainComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'objects',
        component: ProjectDetailObjectsComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'feed',
        component: ProjectDetailFeedComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'widgets',
        component: ProjectDetailWidgetsComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'api',
        component: ProjectDetailApiComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'widgets/:id',
        component: ProjectDetailWidgetDetailComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'widgets/:id',
        component: ProjectDetailWidgetDetailComponent,
        canActivate: [AuthGuard],
      }
    ]
  }
];

@NgModule({
  imports: [
    //RouterModule.forChild(projectsRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class ProjectRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/projects/projects-routing.module.ts